import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/card";

const GET_EVENTS = `
    list_cluster_events (page: 1, limit: 100, is_violation: false) {
        data {
            id
            name
            point
         }
        total
    }
`;
const GET_EVENTS_VIOLATION = `
    list_cluster_events (page: 1, limit: 100, is_violation: true) {
        data {
            id
            name
            point
         }
        total
    }
`;

export default {
	init() {},

	fetchEvents() {
		const queryOptions = {
			query: gql`query Events {
                ${GET_EVENTS}
            }`
		};
		return graphqlClient.query(queryOptions).then(response => {
			const events = response.data.list_cluster_events.data;
			// Sắp xếp tăng dần theo name, sau đó theo point
			events.sort((a, b) => {
				if (a.name === b.name) {
					return a.point - b.point;
				}
				return a.name.localeCompare(b.name);
			});
			return { data: events, total: response.data.list_cluster_events.total };
		});
	},

	fetchEventsViolation() {
		const queryOptions = {
			query: gql`query EventsViolation {
                ${GET_EVENTS_VIOLATION}
            }`
		};
		return graphqlClient.query(queryOptions).then(response => {
			const events = response.data.list_cluster_events.data;
			// Sắp xếp tăng dần theo name, sau đó theo point
			events.sort((a, b) => {
				if (a.name === b.name) {
					return a.point - b.point;
				}
				return a.name.localeCompare(b.name);
			});
			return { data: events, total: response.data.list_cluster_events.total };
		});
	}
};
